module.exports = __webpack_public_path__ + "static/img/m_role.c417805.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/lxx/m_role.png
// module id = V2g5
// module chunks = 7